import React from 'react';
import classNames from 'classnames';

import Button from '../Button/Button';
import {
  ACCESS_DENIED_BODY_CONTACT_PREFIX,
  ACCESS_DENIED_BODY_PRIMARY,
  ACCESS_DENIED_DEFAULT_SUPPORT_EMAIL,
  ACCESS_DENIED_HEADING,
  ACCESS_DENIED_TIP,
} from './accessDenied.constants';

import styles from './AccessDeniedPanel.module.scss';

export type AccessDeniedPanelProps = {
  supportEmail?: string;
  className?: string;
  onCloseButtonClick?: () => void;
};

const AccessDeniedPanel: React.FC<AccessDeniedPanelProps> = ({
  supportEmail = ACCESS_DENIED_DEFAULT_SUPPORT_EMAIL,
  className,
  onCloseButtonClick,
}) => {
  const panel = (
    <section
      className={classNames(styles.panel, className)}
      aria-labelledby="access-denied-heading"
    >
      <h1 id="access-denied-heading" className={styles.heading}>
        {ACCESS_DENIED_HEADING}
      </h1>
      <p className={styles.body}>{ACCESS_DENIED_BODY_PRIMARY}</p>
      <p className={styles.body}>
        {ACCESS_DENIED_BODY_CONTACT_PREFIX}{' '}
        <a href={`mailto:${supportEmail}`} className={styles.link}>
          {supportEmail}
        </a>
        {'.'}
      </p>
      <p className={styles.tip}>{ACCESS_DENIED_TIP}</p>
      {onCloseButtonClick && (
        <div className={styles.actions}>
          <Button
            color="primary"
            variant="contained"
            size="large"
            onClick={onCloseButtonClick}
            label="OK"
          />
        </div>
      )}
    </section>
  );


  return <div className={styles.container}>{panel}</div>;
};

export default AccessDeniedPanel;
